import { useTranslation } from "react-i18next";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import Button from "../../components/shared/button/component";
const LSResetPassword = ({
  onpasswordChange,
  password,
  onconfirmPasswordChange,
  confirmPassword,
  pwdErrorMsg,
  saveClickHandler,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <meta name="description" content={t("reset_password.ls.description_meta")} />
        <title>{t("page_title.reset_password")}</title>
      </Helmet>
      <section className="main-content ">
        <div className="container mx-auto">
          <div className="form-wrap text-center">
            <div className="form-container">
              <hgroup className="text-center user-page">
                <div>
                  <h1 className="text-[#424a5b] font-poppins text-4xl font-extrabold mt-0 mb-2.5 ">
                    {t("reset_password.ls.headline")}
                  </h1>

                  <p className="form-signin-heading text-center">{t("reset_password.ls.sub_headline")}</p>
                </div>
              </hgroup>
              <div className="form-group ">
                <InputText
                  showLabel={false}
                  className="border-gray-300 rounded  p-2 border mb-2 max-w-96"
                  required="required"
                  id="password"
                  text="Password"
                  type="password"
                  name="password"
                  maxlength="128"
                  onChange={onpasswordChange}
                  value={password}
                  placeholder={t("reset_password.placeholder_new_password")}
                />
              </div>
              <div className="form-group">
                <InputText
                  showLabel={false}
                  className=" border-gray-300 rounded  p-2 border mb-2 max-w-96"
                  required="required"
                  id="confirmPassword"
                  text="Password"
                  type="password"
                  name="confirmPassword"
                  maxlength="128"
                  onChange={onconfirmPasswordChange}
                  value={confirmPassword}
                  placeholder={t("reset_password.placeholder_confirm_password")}
                />
              </div>
              <div className="form-text">
                <small className="form-text text-red-500">{pwdErrorMsg}</small>
              </div>
              <div className="align-center fbn bounce-effect fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2 md:p-3 lg:p-3  text-center w-full z-50">
                <Button
                  isLoading={false}
                  disabled={false}
                  id="resetPasswordButton"
                  type="submit"
                  className="bg-[#f9593a] hover:bg-[#424a5b] text-white rounded font-extrabold py-2.5  w-full uppercase md:max-w-80 lg:max-w-80"
                  onClick={saveClickHandler}
                  ctaText={t("reset_password.ls.btn_cta")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LSResetPassword;
